import { extend, localize } from 'vee-validate';
import pl from 'vee-validate/dist/locale/pl';

export function initValidators(validators)
{
    localize('pl', pl);

    for (let [name, validator] of Object.entries(validators)) {
        extend(name, validator);
    }
}